import { Link, useLocation } from "#src/components/Router.tsx";
import { useStore } from "#src/stores/Store.tsx";
import colors from "#src/utils/colors.ts";
import tw from "#src/utils/tw.ts";
import { ReactNode } from "react";

interface Props {
  to?: Location | string;
  className?: string;
  children: ReactNode;
}

export function MenuItem(props: Props) {
  const store = useStore();
  const location = useLocation();

  const isStaff =
    store.isAdminArea || (store.user?.isInstructor && store.isAccountArea);
  const isActive = props.to === location.pathname;

  // console.log("isStaff", isStaff);

  return (
    <Link
      to={props.to}
      className={tw(
        "border-borderGray hover:bg-bgGray flex border-t bg-white font-bold transition",
        props.className
      )}
      data-test={props["data-test"]}
    >
      <div className="flex flex-1 gap-4">
        <div
          className="h-full w-1.5 transition"
          style={{
            backgroundColor: isActive
              ? isStaff
                ? colors.main
                : store.theme.orgColor
              : "transparent",
          }}
        />
        <div
          className={tw(
            "text-organization flex-1 py-2.5 pr-4",
            isActive && "text-dark"
          )}
        >
          {props.children}
        </div>
      </div>
    </Link>
  );
}
